import { useState } from 'react';
export var useOtpInputHandlers = function () {
    var _a = useState(''), code = _a[0], setCode = _a[1];
    var _b = useState('default'), status = _b[0], setStatus = _b[1];
    var reset = function () {
        setCode('');
        setStatus('default');
    };
    return {
        code: code,
        setCode: setCode,
        status: status,
        setStatus: setStatus,
        reset: reset,
    };
};
